import { UserManager, WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';

const env = (import.meta as any).env || {};

const skipSsoFlag = String(env.VITE_SKIP_SSO || 'false') === 'true';
const forceSsoInDev = String(env.VITE_FORCE_SSO || 'false') === 'true';

export const OIDC_CONFIG = {
  authority: env.VITE_OIDC_AUTHORITY as string | undefined,
  clientId: (env.VITE_OIDC_CLIENT_ID as string | undefined) || 'ipc_frontend',
  scope: (env.VITE_OIDC_SCOPE as string | undefined) || 'openid profile',
  /** `npm run dev` 默认不跳 SSO；生产构建只认 VITE_SKIP_SSO。本地要测 SSO 时设 VITE_FORCE_SSO=true */
  skipSSO: skipSsoFlag || (Boolean(env.DEV) && !forceSsoInDev),
};

export type OidcReturnState = {
  returnTo?: string;
};

const buildSettings = (): UserManagerSettings => {
  const origin = window.location.origin;
  const basename = (import.meta as any).env?.BASE_URL || '/';
  if (!OIDC_CONFIG.authority) {
    throw new Error('缺少 VITE_OIDC_AUTHORITY（OIDC authority）配置');
  }
  return {
    authority: OIDC_CONFIG.authority,
    client_id: OIDC_CONFIG.clientId,
    redirect_uri: `${origin}${basename}callback`,
    post_logout_redirect_uri: `${origin}${basename}`,
    response_type: 'code',
    response_mode: 'query',
    scope: 'api openid profile offline_access',
    userStore: new WebStorageStateStore({ store: window.localStorage, prefix: 'oidc.' }),
  };
};

let _mgr: UserManager | null = null;
export const getOidcManager = () => {
  if (_mgr) return _mgr;
  _mgr = new UserManager(buildSettings());
  return _mgr;
};

